import { httpClient } from "@/httpClient";
import getPharmacyID from "@/utils/pharmacy_code";
import { createFileRoute } from "@tanstack/react-router";
import Component from "@/routes/(pharma)/_layout/receipt/-components/component";
import { SaleOne, SearchSchemaReceipt } from "@/routes/(pharma)/_layout/receipt/-data/model";
import { Loading } from "@/layouts/loading";
import { GetSaleResponse } from "@/gen/sales/get_sale_pb";
import { pharmacyClient } from "@/connect";

const API_URL = import.meta.env.VITE_API_URL as string

export const Route = createFileRoute('/(pharma)/_layout/receipt/$saleId')({
    component: Component,
    validateSearch: SearchSchemaReceipt,
    loader: async ({params}): Promise<GetSaleResponse> => {
        if (!params.saleId) {
            throw new Error("Sale ID is required");
        }
        
        return await pharmacyClient.getSale({
            saleId: params.saleId,
        })
    },
    pendingComponent: () => <Loading />,
    pendingMinMs: 1000,
    pendingMs: 1
});